import React from "react";

type Props = {
  info: string | number;
  subInfo: string;
};

const Info: React.FC<Props> = ({ info, subInfo }): JSX.Element => {
  return (
    <div className="flex flex-col">
      <div className="flex flex-row my-auto">
        <div
          className="font-nunito text-4xl text-bt-green"
          style={{
            fontStyle: "normal",
            fontWeight: 600,
          }}
        >
          {info}
        </div>
        <div
          className="mt-3 ml-2 font-nunito text-base text-bt-gray-500"
          style={{
            fontStyle: "normal",
            fontWeight: 400,
          }}
        >
          {subInfo}
        </div>
      </div>
    </div>
  );
};

export default Info;
